import colors from './colors'

const formStyles = {
  legend: {
    fontSize: '16px',
    fontWeight: '700'
  },
  group: {
    fieldset: {
      padding: '.6rem',
      border: `${colors.darkNeutral} solid 1px`,
      borderRadius: '.5em'
    },
    legend: {
      width: 'auto',
      fontSize: 'medium',
      padding: '0 .5em',
      fontFamily: "'Open Sans', sansSerif",
      fontWeight: '700',
      color: colors.primary,
      lineHeight: '1.1'
    },
    description: {
      fontStyle: 'italic'
    }
  },
  label: { fontWeight: '700' },
  inlineContainer: {
    display: 'inline-flex',
    flexDirection: 'row',
    columnGap: '15px'
  }
}

export default formStyles
